import { Component, OnInit } from '@angular/core';
import * as L from 'leaflet';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { Map, icon } from 'leaflet';
import { CstemapiService } from '../cstemapi.service';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { PlatformLocation } from '@angular/common';
import * as $ from 'jquery';

@Component({
  selector: 'app-outputs',
  templateUrl: './outputs.component.html',
  styleUrls: ['./outputs.component.scss']
})
export class OutputsComponent implements OnInit {
  options;
  layers: any = [];
  map;
  marker;
  userLat = 23.040;
  userLong = 78.389;
  albidoFactor: any = [];
  aFactor;
  userLoc: any = {};
  simulatedPlantList: any;
  plantSummaryReport: any;
  inputSummary: any;
  chooseoption: any;
  layersControl: any;

  constructor(public cstemapi: CstemapiService, private auth: AuthService, private myRoute: Router, location: PlatformLocation) {
    this.aFactor = "4";
    this.userLoc = this.auth.getUserLocation();

    /* this function is called from appinputs page becaouse of lat long problems */
    // this.getPlantSummary();

    this.plantSummaryReport = this.auth.getPlantSummaryReport();
    this.chooseoption = this.auth.getPlantSummaryReport().caseDetailsEntity;
    if (this.auth.getPlantSummaryReport().caseDetailsEntity.applicationTypeCode != 'util') {
      this.auth.saveDailyLoad(this.auth.getPlantSummaryReport().batteryDetails.dailyLoad);
    }

    location.onPopState(() => {
      setTimeout(() => {
        this.myRoute.navigateByUrl("/demo")
      }, 500);
    });

    if (this.auth.getGuestUserId() != '' && this.auth.getIsGuest() == 'true') {
      this.cstemapi.disablechart();
    } else {
      this.cstemapi.enablechart();
    }
  }


  ngOnInit() {
    $(document).ready(function () {
      $('.sidelinks-sm').click(function () {
        $('.sidelinks').toggle();
      })
    })
    if (window.scrollY) {
      window.scroll(0, 0);  // reset the scroll position to the top left of the document.
      let top = document.getElementById('intro');
      if (top !== null) {
        top.scrollIntoView();
        top = null;
      }
    }

    this.options = {
      zoom: 12,
      center: L.latLng([this.userLoc.lat, this.userLoc.long]),
      timeDimension: true,
      timeDimensionControl: true,
      zoomControl: false,
      doubleClickZoom: false,
      scrollWheelZoom: false
    };

    var styled = L.gridLayer.googleMutant({
      type: 'roadmap', // valid values are 'roadmap', 'satellite', 'terrain' and 'hybrid'
      styles: [{
        stylers: [{
          saturation: -100 // greyscale map
        }]
      }]
    });

    var styled1 = L.gridLayer.googleMutant({
      type: 'roadmap', // valid values are 'roadmap', 'satellite', 'terrain' and 'hybrid'
      // styles: [{
      //   stylers: [{
      //     saturation: -100 // greyscale map
      //   }]
      // }]
    });

    var satellite = L.gridLayer.googleMutant({
      type: 'satellite', // valid values are 'roadmap', 'satellite', 'terrain' and 'hybrid'
    });

    var terrain = L.gridLayer.googleMutant({
      type: 'terrain', // valid values are 'roadmap', 'satellite', 'terrain' and 'hybrid'
    });


    this.layers = [styled];

    this.layersControl = {
      baseLayers: {
        'Default': styled,
        'Road Map': styled1,
        'Satellite': satellite,
        'Terrain': terrain
      }
    }
  }

  ngAfterViewInit() {

  }

  onMapReady(map: Map) {
    this.map = map;
    var vm = this;

    vm.marker = L.marker([this.userLoc.lat, this.userLoc.long], {
      icon: L.icon({
        iconSize: [25, 41],
        iconAnchor: [13, 41],
        iconUrl: vm.cstemapi.assetUrl + 'images/marker-icon.png',
        shadowUrl: vm.cstemapi.assetUrl + 'images/marker-shadow.png'
      })
    });
    vm.map.addLayer(vm.marker)

    // map.panBy([300, 0]);
  }

  capitalChart(cdata) {
    am4core.useTheme(am4themes_animated);

    var chart = am4core.create("capChart", am4charts.PieChart);
    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

    chart.data = [{
      country: 'Civil and General Works',
      value: cdata.civilAndGeneralWorks
    }, {
      country: 'Indirect Expenses',
      value: cdata.indirectExpenses
    }, {
      country: 'Land',
      value: cdata.land
    }, {
      country: 'Mounting Structure',
      value: cdata.mountingStructure
    }, {
      country: 'PCU Inverter',
      value: cdata.pcu_inverter
    }, {
      country: 'Power Evacuation Infrastructure',
      value: cdata.powerEvacuationInfrastructure
    }, {
      country: 'PV Modules',
      value: cdata.pvModules
    }]

    var series = chart.series.push(new am4charts.PieSeries());
    series.dataFields.value = "value";
    series.dataFields.radiusValue = "value";
    series.dataFields.category = "country";
    series.slices.template.cornerRadius = 6;
    series.colors.step = 3;

    series.hiddenState.properties.endAngle = -90;

    chart.legend = new am4charts.Legend();
  }

  scrollToView(id) {
    var elmnt = document.getElementById(id);
    elmnt.scrollIntoView({
      behavior: 'smooth'
    });
  }

  test(e) {
    // console.log(e)
    if (e.nextId == '8') {
      this.myRoute.navigate(['/chooseoption'])
    }
  }
}
